import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HttpClientXml from "../utils/HttpClientXml";
import HomeService from "../Services/HomeService";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  // color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ViewReportProperty() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);

  const showComplaintPopup = (complaint) => {
    Swal.fire({
      title: "Complaint Details",
      html: `
        <div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px;">
          <p style="white-space: pre-wrap; line-height: 1.5; font-size: 14px;">
            ${complaint || "No complaint provided"}
          </p>
        </div>
      `,
      width: "600px",
      confirmButtonText: "Close",
      confirmButtonColor: "#477DA5",
    });
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },

    {
      name: "Property Details",
      selector: (row) => row.propertyDetails?.address || "N/A",
      sortable: true,
      cell: (row) => (
        <div>
          <div>
            <strong>For:</strong> {row.propertyDetails?.propertyFor || "N/A"}
          </div>
          <div>
            <strong>City:</strong> {row.propertyDetails?.city || "N/A"}
          </div>
          <div>
            <strong>Locality:</strong> {row.propertyDetails?.locality || "N/A"}
          </div>
          <div>
            <strong>Address:</strong> {row.propertyDetails?.address || "N/A"}
          </div>
          <div>
            <strong>Price:</strong> {row.propertyDetails?.price}{" "}
            {row.propertyDetails?.priceUnit}
          </div>
        </div>
      ),
    },
    {
      name: "Reported By",
      selector: (row) => row.userDetails?.fullName || "Anonymous",
      sortable: true,
      cell: (row) => (
        <div>
          <div>
            <strong>Name:</strong> {row.userDetails?.fullName || "N/A"}
          </div>
          <div>
            <strong>Email:</strong> {row.userDetails?.email || "N/A"}
          </div>
          <div>
            <strong>Mobile:</strong> {row.userDetails?.mobileNo || "N/A"}
          </div>
        </div>
      ),
    },
    {
      name: "Complaint",
      selector: (row) => row.complaint || "No complaint provided",
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
          onClick={() => showComplaintPopup(row.complaint)}
        >
          <span title="Click to view full complaint">
            {row.complaint
              ? row.complaint.length > 10
                ? `${row.complaint.substring(0, 10)}...`
                : row.complaint
              : "No complaint provided"}
          </span>
          {row.complaint && (
            <i
              className="fa-solid fa-eye"
              style={{
                color: "#477DA5",
                fontSize: "14px",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.color = "#2c5282";
              }}
              onMouseLeave={(e) => {
                e.target.style.color = "#477DA5";
              }}
            ></i>
          )}
        </div>
      ),
    },
    {
      name: "Reported Date",
      selector: (row) => new Date(row.createdOn).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <span title="Delete" onClick={() => handleDelete(row._id)}>
          <i
            className="fa-solid fa-trash-can text-danger"
            style={{
              cursor: "pointer",
              padding: "8px",
              fontSize: "1.3em",
              color: "#477DA5",
              backgroundColor: "#E9F3F7",
              borderRadius: "4px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#ffebee";
              e.target.style.color = "#dc3545";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#E9F3F7";
              e.target.style.color = "#477DA5";
            }}
          ></i>
        </span>
      ),
      width: "100px",
    },
  ];

  const fetchAllReports = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getReportProperties();
      console.log("Reports data:", res.data);
      setReports(res.data || []);
      // toast.success("Reports loaded successfully!");
    } catch (error) {
      console.error("Error fetching reports:", error);
      toast.error("Failed to load reports!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllReports();
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Report?",
      text: "Are you sure you want to delete this property report?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await HomeService.deleteReportProperty(id);
        Swal.fire("Deleted!", "Property report has been deleted.", "success");
        fetchAllReports(); // Refresh the list
      } catch (error) {
        console.error("Error deleting report:", error);
        Swal.fire("Error!", "Failed to delete property report.", "error");
      }
    }
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "60px",
        fontSize: "14px",
      },
    },
    headCells: {
      style: {
        // backgroundColor: "#477DA5",
        color: "black",
        fontWeight: "bold",
        fontSize: "14px",
        padding: "12px 8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div className="mt-5">
            <div style={headLineStyle} className="page-headline">
              Property Reports
            </div>

            <DataTable
              columns={columns}
              data={reports}
              pagination
              responsive
              highlightOnHover
              striped
              customStyles={customStyles}
              progressPending={loading}
              noDataComponent={
                <div className="text-center py-4">
                  <i
                    className="fa-solid fa-file-circle-exclamation"
                    style={{
                      fontSize: "3rem",
                      color: "#868e96",
                      marginBottom: "1rem",
                    }}
                  ></i>
                  <p style={{ color: "#868e96", fontSize: "1.1rem" }}>
                    No property reports found
                  </p>
                </div>
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewReportProperty;
